import React, { useEffect } from "react";
import { Modal, Input, Select, Form, Radio } from "antd";
import { observer } from "mobx-react";
import { channelInvitationsStore } from "../../../store/invitation/ChannelInvitationsStore";
import { defaultFormLayout } from "../../../common/Utils";

export const ChannelInvitationDlg = observer(() => {
  const [form] = Form.useForm();

  const save = () => {
    form.validateFields().then((values) => {
      channelInvitationsStore.edit.save(values);
    });
  };

  useEffect(() => {
    console.log("init", channelInvitationsStore.edit.model);
    form.setFieldsValue({ ...channelInvitationsStore.edit.model });
  }, []);

  return (
    <Modal
      title={`Edit Invitation`}
      visible={channelInvitationsStore.edit.visible}
      onOk={() => save()}
      maskClosable={false}
      confirmLoading={channelInvitationsStore.edit.saving}
      onCancel={() => channelInvitationsStore.edit.close()}
    >
      <Form form={form} {...defaultFormLayout} initialValues={channelInvitationsStore.edit.model}>
        <Form.Item label="Campaign Name" name="name" rules={[{ required: true, message: "Please input name" }]}>
          <Input placeholder="Enter Campaign Name" />
        </Form.Item>
        <Form.Item
          label="Code"
          name="code"
          rules={[
            { required: true, message: "Please input code" },
            { pattern: /^0\d{5}$/, message: "Invalid code." },
          ]}
        >
          <Input placeholder="Enter code" maxLength={6} />
        </Form.Item>
        <Form.Item
          label="Community"
          name="communityId"
          rules={[{ required: true, message: "Please select community" }]}
        >
          <Select showSearch>
            {channelInvitationsStore.edit.communities.map((x: any) => (
              <Select.Option value={x.id} key={x.id}>
                {x.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Status" name="state">
          <Radio.Group>
            <Radio value="Active">Active</Radio>
            <Radio value="Retired">Retired</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Notes" name="notes">
          <Input.TextArea placeholder="Enter notes" />
        </Form.Item>
      </Form>
    </Modal>
  );
});
